__turbopack_context__.v({
  "arrow": "tMjT2W_arrow",
  "avatarContainer": "tMjT2W_avatarContainer",
  "viewMore": "tMjT2W_viewMore",
});
